import clsx from 'clsx';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { IBasicItem } from '../../../../models/IBasicItem';
import { IProfileForm } from '../../../../models/Profile/IProfileForm';
import styles from './DropdownEdit.module.css';

const DropdownEdit = React.forwardRef<
  HTMLSelectElement,
  {
    items: IBasicItem[];
    label?: string;
    placeholderLabel?: string;
    selectedValue?: string;
    propStyle?: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    multiple?: boolean;
    onChange?: (event: string) => void;
  } & ReturnType<UseFormRegister<IProfileForm> & any>
>((props, ref) => {
  return (
    <div className={clsx(styles.container, props.propStyle, props.className)}>
      {props.label && (
        <>
          <label className={clsx(styles.label, props.error && styles.errorLabel)}>
            {props.label}
          </label>
          {props.required && <span style={{ color: 'var(--shrmRed)' }}>*</span>}
        </>
      )}
      <div className={props.multiple && styles.noteContainer}>
        <select
          className={clsx(
            props.multiple ? styles.multiSelect : styles.select,
            props.error && styles.error
          )}
          multiple={props.multiple}
          name={props.name}
          // onChange={props.onChange}
          onChange={event => {
            props.onChange(event);
          }}
          onBlur={props.onBlur}
          disabled={props.disabled}
          ref={ref}
          value={props.selectedValue ? props.selectedValue : undefined}
        >
          {props.placeholderLabel && <option value=''>{props.placeholderLabel}</option>}
          {props.items &&
            Array.isArray(props.items) &&
            props.items.map((item: IBasicItem) => (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            ))}
        </select>
        {props.multiple && (
          <div className={styles.multiSelectNote}>
            <p className={styles.label}>{'Note:'}</p>
            <p>
              {
                'Hold down Ctrl (Windows) or Command (Mac) key while clicking to select multiple options.'
              }
            </p>
          </div>
        )}
      </div>
    </div>
  );
});

export default DropdownEdit;
